import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const postTypeResolver: FieldResolver = (metadata: Metadata) =>
  ({ postType: metadata.getPostType() } as StreamData)

export default postTypeResolver
